import { Injectable } from '@angular/core';
import { BaseRepository } from '../../repository/base';

@Injectable({ providedIn: 'root' })
export abstract class BaseService<T> {
  protected readonly repository: BaseRepository<T>;

  constructor(repository: BaseRepository<T>) {
    this.repository = repository;
  }

  public async count(filter: any): Promise<number> {
    return this.repository.count(filter);
  }

  public async exists(filter: any): Promise<boolean> {
    return this.repository.exists(filter);
  }

  public async create(data: T): Promise<T> {
    return this.repository.create(data);
  }

  public async upsert(data: T): Promise<T> {
    return this.repository.upsert(data);
  }

  public async update(id: any, data: T): Promise<T> {
    return this.repository.update(id, data);
  }

  public async replace(id: any, data: T): Promise<T> {
    return this.repository.replace(id, data);
  }

  public async delete(id: any): Promise<boolean> {
    return this.repository.delete(id);
  }

  public async find(filter: any): Promise<T[]> {
    return this.repository.find(filter);
  }

  public async findOne(filter: any): Promise<T> {
    return this.repository.findOne(filter);
  }

  public async findById(id: any): Promise<T> {
    return this.repository.findById(id);
  }
}
